/**
 * Aligns with @literati/public-ui-shared-react theme/font (DLS typography tokens).
 * Required for styled-components that read theme.font.* under DefaultThemeProvider.
 */
module.exports = {
  fontFamily: {
    hoefler: "hoefler, serif",
    hoeflerTitling: "hoefler-titling, serif",
    avenir: "avenir, sans-serif",
  },
  weight: {
    roman: 400,
    bold: 700,
    black: 800,
    heavy: 900,
  },
};
